import React from 'react';
import { FC } from 'react';
import { SelectField } from '../atomic/forms';

export type YearMonthSelectorProp = {
    onDateChange: any;
    after?: number;
};
export const YearMonthSelector: FC<YearMonthSelectorProp> = ({
    onDateChange,
    after = 2020, //2020年以降現在までをリストに含む
}) => {
    const [selectedDate, setSelectedDate] = React.useState(new Date());

    const [year, setYear] = React.useState(
        selectedDate.getFullYear().toString()
    );
    const [month, setMonth] = React.useState(
        (selectedDate.getMonth() + 1).toString()
    );

    // 年を変更する関数
    const handleYearChange = (target: string) => {
        const newYear = parseInt(target);
        const currentMonth = selectedDate.getMonth();
        const newDate = new Date(newYear, currentMonth, 1);
        setSelectedDate(newDate);
        if (onDateChange) {
            onDateChange(newDate);
        }
    };

    // 月を変更する関数
    const handleMonthChange = (target: string) => {
        const newMonth = parseInt(target) - 1; // date-fnsの月は0から始まる
        const currentYear = selectedDate.getFullYear();
        const newDate = new Date(currentYear, newMonth, 1);
        setSelectedDate(newDate);
        if (onDateChange) {
            onDateChange(newDate);
        }
    };

    const nowYear = new Date().getFullYear();

    const yearOptions = Array.from({ length: nowYear - after + 1 }, (_, i) => {
        const year = after + i;
        return { text: `${year}年`, value: year.toString() };
    });
    const monthOptions = Array.from({ length: 12 }, (_, i) => {
        const month = i + 1;
        return { text: `${month}月`, value: month.toString() };
    });
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <SelectField
                label=""
                value={year}
                _onChange={(e) => {
                    handleYearChange(e);
                    setYear(e);
                }}
                options={yearOptions}
            />
            <SelectField
                label=""
                value={month}
                _onChange={(e) => {
                    handleMonthChange(e);
                    setMonth(e);
                }}
                options={monthOptions}
            />
        </div>
    );
};
